import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { Browser, enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';
import { DateTimeService, AreaSeriesService } from '@syncfusion/ej2-angular-charts'
import { LegendService, ZoomService } from '@syncfusion/ej2-angular-charts'
// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');
import { projectData, sampleData } from 'src/app/components/grid/jobs-grid/jsontreegredidata';
import { ChartComponent, ChartTheme, ILoadedEventArgs, IPointEventArgs } from '@syncfusion/ej2-angular-charts';
@Component({
  selector: 'app-metric-char-data-examples',
  templateUrl: './metric-char-data-examples.component.html',
  styleUrls: ['./metric-char-data-examples.component.scss'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService, DataService, AreaSeriesService, LegendService, ZoomService]

})
export class MetricCharDataExamplesComponent implements OnInit {



  // public data: Object[] = [];
  
  @Input() sent_data?: any; // not used

  // public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('grid2') public grid2: GridComponent;
  @ViewChild('grid3') public grid3: GridComponent;
  // public grid: GridComponent;
  public searchOptions: SearchSettingsModel;

  public groupOptions: GroupSettingsModel;
  // public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;


  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
  public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both



     // setup as observable?
     @Input() item_id?: any; // impliments on changes.
     @Input() item_data?: any; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full

       // TABS sets the selected
  @ViewChild('staticTabs') staticTabs!: TabsetComponent;
  selected_tab?: number;


    public title?: string;

    search_results: any;
  woo_orders: any;
  graph_data: Object[];
  search_results_clone_START: any;
  moviesByRating: any[];
  user_login_count: number;
  user_logout: any[];
  user_logout_count: number;
  user_forced_logout_ON: any[];
  user_forced_logout_ON_count: number;
  user_forced_logout_OFF: any[];
  user_forced_logout_OFF_count: number;
  log_types_mapped_numbers: any[];
  log_types_mapped_labels: any[];
  Chart2_title: string;

  chartData_client: { log_type_name: string; sum: number; color: string; }[];
  chartData_agent: { log_type_name: string; sum: number; color: string; }[];
  chartData_staff: { log_type_name: string; sum: number; color: string; }[];


  Chart2_users_data: any;
  search_results_START: any;
  search_results_clone: any;
  
  Chart3_title: string;
  Chart3_marker: { visible: boolean; width: number; height: number; shape: string; };
  Chart3_tooltip: { enable: boolean; template: any; };
  Chart3_tooltipTemplate: any;
  Chart3_all_data: { log_type_name: any; sum: any; color: string; created_date: Date; }[];



  Chart4_title: string;
  Chart4_marker: { visible: boolean; width: number; height: number; shape: string; };
  Chart4_tooltip: { enable: boolean; template: any; };
  Chart4_tooltipTemplate: any;
  Chart4_all_data: { log_type_name: any; sum: any; color: string; created_date: Date; }[];





  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };

  today = new Date(); // this date worked to compare dates with ZISo date format in database.
  today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
  action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
  action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison

woo_products: any;
sessionUserId: any;
sessionUsername: any;
all_router_details: string;
sessionBrandId: any;
initialPage: { pageSize: number; };
woo_products_object: any;
public page_collection = [];
sessionUserName: string;
sessionUserLevel: number;
sessionUserFullName: string;
sessionUserFirstName: string;



    //syncfusion charts
    @ViewChild('chart')
    public chart: ChartComponent;
    public primaryXAxis: Object;
  
    // public chartData: Object[];
    public chartData: any;

  public marker: Object;
  public tooltip: Object;
  public Chart2_marker: Object;
  public Chart2_tooltip: Object;
  
  public primaryYAxis: Object;
  public cornerRadius: Object;
  public chartArea: Object;
  public animation: Object;
  public pointColorMapping: string;
  system_log_types: Object;
  results_countBy: _.Dictionary<number>;
  list_countBy: any;
  results_map: any;
  results_user_names: any[];
  result_keyBy: _.Dictionary<any>;
  result_filter: any[];
  results_user_log_array: any[];
  ChartData_filtered_user_performance: { name: string; log_type_name: string; count: number; }[];
  ChartData_filtered_user_performance_FULL: any;
  legendSettings: any;
  
  public pointClick(args: IPointEventArgs): void {
    document.getElementById("lbl").innerText = "Type : "+ args.point.x + "\nSum : "+ args.point.y  + "\nY : "+ args.series.name;
  };
  public pointClick_meta(args: IPointEventArgs): void {
    document.getElementById("lbl_meta").innerText = "Type : "+ args.point.x + "\nSum : "+ args.point.y  + "\nY : "+ args.series.name;
  };
  
  primaryXAxis_DateTimeCategory = {
    // valueType: 'DateTimeCategory'
    // valueType: 'Category'
    valueType: 'DateTime'
    
  };


  primaryXAxis_Category = {
    // valueType: 'DateTimeCategory'
    valueType: 'Category',
    // valueType: "Category",
    title: "Activies",
    visible: true
    // valueType: 'DateTime'
    
  };
  
  public tooltipTemplate: string =
  "<div id='templateWrap'><table style='width:100%;border: 1px solid black;'><tr><th colspan='2'  bgcolor='#00FFFF'>Female</th></tr><tr><td bgcolor='#00FFFF'>${x}:</td><td bgcolor='#00FFFF'>${y}</td></tr></table></div>";
  
  public Chart2_tooltipTemplate: string =
  "<div id='templateWrap'><table style='width:100%;border: 1px solid black;'><tr><th colspan='2'  bgcolor='#00FFFF'>Female</th></tr><tr><td bgcolor='#00FFFF'>${x}:</td><td bgcolor='#00FFFF'>${y}</td></tr></table></div>";
  
  
  
  
    // chart: c3.ChartAPI; -- Disable if using syncfusion charts
          // @ViewChild('chart') chart: c3.ChartAPI;
          chart_guage: c3.ChartAPI; // @ViewChild('chart_guage') 
  
  
  
           // toggle elements
          //  isShow = true;
          isShow_chart1 = false;
          isShow_chart2 = false;
          isShow_chart4 = false; // new staff metrics perspective.
          
          isShow_chart1_meta = false;
          isShow_chart2_meta = false; // user investigation as default
          isShow_chart3_meta = false; // user investigation as default


// Chart Staff User Solo
public chartData2: any;
public pointColorMapping2: string = "log_type_colour";
public tooltip2: Object;
public legendSettings2: Object;
  // Define default values
  private readonly DEFAULT_COLOR = "#cccccc";
  private readonly DEFAULT_ICON = "fa fa-question-circle";
 
  public highScoreAnnotation: any[] = [];
  public lowScoreAnnotations: any[] = [];
 



  constructor(
        // private productService: WoocommerceProductsService,
    // private orderService: WoocommerceOrderService,
    private http: HttpClient, private router: Router,
      private route: ActivatedRoute, private _demoService: DemoService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private modalService: BsModalService,
     public toastr: HotToastService,
     vcr: ViewContainerRef,
     private _mysqlService: MysqlService,
  ) {  




    // build Staff 

          // Tooltip configuration with icon
          // Tooltip configuration with function binding for custom content
         
         
          // this.tooltip2 = {
          //   enable: true,
          //   text: this.getTooltipContent.bind(this) // Bind the custom tooltip content function
          // };

          this.tooltip2 = {
            enable: true
        };

          // Legend configuration
          this.legendSettings2 = {
            visible: true,
            position: 'Bottom',
            shape: 'Circle'
          };



    this.legendSettings = { visible: true, position: "Right" };
    this.pointColorMapping = "color";
  }

  ngOnInit(): void {



  }



  ngOnChanges(changes) {

    // this.getSystemLogTypes();


this.woo_orders = this.item_data; // sets the data regardless.

       if (changes.item_id) {
         // deal with asynchronous Observable result
         this.item_id = changes.item_id.currentValue;
       }


       if (changes.item_data) {
         // deal with asynchronous Observable result
         // this.getJob(this.job_id);
       // console.log('On changes Sent Action List Id:' + this.action_list_id);
       // this.generateChart();

         // this commnad dynamically loads data int the fhart
       // this.chart.load({
       //   columns: [
       //     ['data4', 300, 100, 250, 150, 300, 150, 500],
       //     ['data5', 100, 200, 150, 50, 100, 250]
       //   ]
       // });

       this.woo_orders = changes.item_data.currentValue;

                

                               // a simple pause to load the log_typ
      // if for meta or live data.
      
        setTimeout(() => {  
      
        this.systemLogNumbersExamples(this.item_data)
        this.systemLogNumbers_ByUserLogsMetric(this.item_data)
        this.systemLogNumbers_ByUserLogsMetric_FULL(this.item_data)
         // New seperate
         // this.load_Chart1(this.woo_orders)


         if (this.item_data) {




          
          this.chartData2 = this.transformItemData2ToChartData(this.item_data);
          this.calculateAnnotations();  // Calculate annotations when data updates
        }


       }, 1000);
                      


     //  this.setupOrderCounts(this.woo_orders);
       // this.getActionList(this.action_list_id);
       // this.loadashExamples(this.woo_orders);

       // console.log('Item Data: ' + JSON.stringify(this.item_data));
       // console.log('Woo Orders: ' + JSON.stringify(this.woo_orders));


// Reload Counds
// this.loadCompletedItemsPercentage(this.total_completed_items_percentage, 'chart_guage', 'Total Complete', '180');
// this.loadCompletedItemsPercentage(this.total_cp_items_completed_percentage, 'total_cp_items_completed', 'CP Completed', '120');
//  this.loadCompletedItemsPercentage(this.total_mail_items_completed_percentage, 'total_mail_items_completed', 'MAIL Completed', '120');
//  this.loadCompletedItemsPercentage(this.total_checkout_mail_items_completed_percentage, 'total_checkout_mail_items_completed', 'Woo Checkout Completed', '250');

       }


     }





     systemLogNumbersExamples(send_data){
      this.search_results = send_data; // works for meta pass - not direct orders via mysql?
      this.graph_data = new DataManager(this.search_results as JSON[]).executeLocal(new Query()); // Sets the grid data for the graphs //.take(100)
    
    
      // Collections
      // countBy - 
      // Creates an object composed of keys generated from the results of running each element of collection thru iteratee. The corresponding value of each key is the number of times the key was returned by iteratee. The iteratee is invoked with one argument: (value)
      // this.list_countBy = [1.1, 2.1, 2.3]
      this.list_countBy = this.search_results
      var result_countBy = _.countBy(this.list_countBy, Math.floor);
      // console.log(result_countBy);
      this.results_countBy = result_countBy;



      // _map -
      // Creates an array of values by running each element in collection thru iteratee. The iteratee is invoked with three arguments: (value, index|key, collection)
       let list_map = this.search_results

       var result = _.map(list_map, 'user_logs_array'); // get the counts for each user and logtypes
       this.results_user_log_array = result;
       var result_user_names = _.map(list_map, 'name'); // get the counts for each user and logtypes
       

      this.results_user_names = result_user_names;
       this.results_map = result;


      //keyBy
      var result_keyBy = _.keyBy(this.results_user_log_array, 'user_login');
      this.result_keyBy = result_keyBy;



      // try using a filet -- not currently working...
      let result_filter = _.filter(this.results_user_log_array, function(logs) { 
       if(logs.log_type_name == 'user_login'){
        return logs; 
       }
      });
      this.result_filter = result_filter;

      // end collections




      // First Step removes the empties from the object.
      // Remove empty arrays -- removes [] that are emtpy.
const filteredData = this.results_user_log_array.filter(item => item.length > 0);


// Flatten the filtered data to a single array of objects
const flattenedData = filteredData.flat();

// Reduce to a single object with log_type_name as keys and counts as values
const result_flat = flattenedData.reduce((acc, obj) => {
    const { log_type_name, count } = obj;
    if (!acc[log_type_name]) {
        acc[log_type_name] = 0;
    }
    acc[log_type_name] += count;
    return acc;
}, {} as Record<string, number>);

// console.log(result_flat);


        // Tooltip configuration
        this.tooltip = {
          enable: true,
          format: '${point.x} : ${point.y} <br> ',
          shared: false,
      };


this.chartData = flattenedData // if I add the brackets it makes the object an array.>


    }  





// Gets all users, and thier logs types counts (basic,)
    systemLogNumbers_ByUserLogsMetric(send_data){

      let list_map = send_data
      var result = _.map(list_map, 'user_logs_array'); // get the all the metric items for each user and logtypes

      // cleans the object for empty objects. []
      const filteredData = result.filter(item => item.length > 0); //!important for the graph to calculate properly

      // chat GTP -- Works well for basic information. after I filter the user logs array within each record.
      function aggregateLogs(data: Array<Array<{ count: number, log_type_name: string, name: string }>>): Array<{ name: string, log_type_name: string, count: number }> {
        // Flatten the data
        const flattenedData = data.flat();
    
        // Create an object to hold the aggregation
        const result: Record<string, Record<string, number>> = {};
    
        // Loop through the flattened data
        flattenedData.forEach(({ count, log_type_name, name }) => {
            if (!result[name]) {
                result[name] = {};
            }
            if (!result[name][log_type_name]) {
                result[name][log_type_name] = 0;
            }
            result[name][log_type_name] += count;
        });
    
        // Convert the result object to the desired output format
        const output: Array<{ name: string, log_type_name: string, count: number }> = [];
    
        for (const name in result) {
            for (const log_type_name in result[name]) {
                output.push({
                    name,
                    log_type_name,
                    count: result[name][log_type_name]
                });
            }
        }
    
        return output;
    }
    
    // Usage
    const aggregatedData = aggregateLogs(filteredData);
    // console.log(aggregatedData);

    this.ChartData_filtered_user_performance = aggregatedData;




    }



    // Full gets all values, benchmarks and calculations and ratings etc.. load for graphing.
  systemLogNumbers_ByUserLogsMetric_FULL(send_data){

      let list_map = send_data
      var result = _.map(list_map, 'user_logs_array'); // get the all the metric items for each user and logtypes

      // cleans the object for empty objects. []
      // const filteredData = result.filter(item => item.length > 0); //!important for the graph to calculate properly

      // chat GTP -- Works well for basic information. after I filter the user logs array within each record.
      function aggregateLogs(data: Array<Array<{
        count: number,
        log_type_name: string,
        name: string,
        unit_per_day?: number,
        log_type_id?: number,
        when_from?: string,
        when_to?: string,
        Duration?: number,
        benchmark_duration?: number,
        difference_duration?: number,
        rating_duration?: number,
        tolerance_duration?: number,
        days_duration?: number,
        log_type_icon?: string,
        log_type_colour?: string
    }>>): Array<{
        name: string,
        log_type_name: string,
        count: number,
        unit_per_day?: number,
        log_type_id?: number,
        when_from?: string,
        when_to?: string,
        Duration?: number,
        benchmark_duration?: number,
        difference_duration?: number,
        rating_duration?: number,
        tolerance_duration?: number,
        days_duration?: number,
        log_type_icon?: string,
        log_type_colour?: string
    }> {
        // Flatten the data
        const flattenedData = data.flat();
    
        // Use a Map to store aggregation by name and log_type_name
        const result = new Map<string, Map<string, {
            count: number,
            unit_per_day?: number,
            log_type_id?: number,
            when_from?: string,
            when_to?: string,
            Duration?: number,
            benchmark_duration?: number,
            difference_duration?: number,
            rating_duration?: number,
            tolerance_duration?: number,
            days_duration?: number,
            log_type_icon?: string,
            log_type_colour?: string
        }>>();
    
        // Loop through the flattened data
        flattenedData.forEach(({
            count, log_type_name, name, unit_per_day, log_type_id, when_from, when_to,
            Duration, benchmark_duration, difference_duration, rating_duration, tolerance_duration,
            days_duration, log_type_icon, log_type_colour
        }) => {
            if (!result.has(name)) {
                result.set(name, new Map());
            }
            const logTypeMap = result.get(name)!;
    
            if (!logTypeMap.has(log_type_name)) {
                logTypeMap.set(log_type_name, {
                    count: 0, unit_per_day, log_type_id, when_from, when_to, Duration, benchmark_duration,
                    difference_duration, rating_duration, tolerance_duration, days_duration, log_type_icon, log_type_colour
                });
            }
    
            const logEntry = logTypeMap.get(log_type_name)!;
            logEntry.count += count;
    
            // If needed, update other fields based on your logic
            logEntry.unit_per_day = unit_per_day ?? logEntry.unit_per_day;
            logEntry.log_type_id = log_type_id ?? logEntry.log_type_id;
            logEntry.when_from = when_from ?? logEntry.when_from;
            logEntry.when_to = when_to ?? logEntry.when_to;
            logEntry.Duration = Duration ?? logEntry.Duration;
            logEntry.benchmark_duration = benchmark_duration ?? logEntry.benchmark_duration;
            logEntry.difference_duration = difference_duration ?? logEntry.difference_duration;
            logEntry.rating_duration = rating_duration ?? logEntry.rating_duration;
            logEntry.tolerance_duration = tolerance_duration ?? logEntry.tolerance_duration;
            logEntry.days_duration = days_duration ?? logEntry.days_duration;
            logEntry.log_type_icon = log_type_icon ?? logEntry.log_type_icon;
            logEntry.log_type_colour = log_type_colour ?? logEntry.log_type_colour;
    
            logTypeMap.set(log_type_name, logEntry);  // Update logTypeMap with the new aggregated data
        });
    
        // Convert the Map to the desired output format
        const output: Array<{
            name: string,
            log_type_name: string,
            count: number,
            unit_per_day?: number,
            log_type_id?: number,
            when_from?: string,
            when_to?: string,
            Duration?: number,
            benchmark_duration?: number,
            difference_duration?: number,
            rating_duration?: number,
            tolerance_duration?: number,
            days_duration?: number,
            log_type_icon?: string,
            log_type_colour?: string
        }> = [];
    
        result.forEach((logTypeMap, name) => {
            logTypeMap.forEach((entry, log_type_name) => {
                output.push({
                    name,
                    log_type_name,
                    count: entry.count,
                    unit_per_day: entry.unit_per_day,
                    log_type_id: entry.log_type_id,
                    when_from: entry.when_from,
                    when_to: entry.when_to,
                    Duration: entry.Duration,
                    benchmark_duration: entry.benchmark_duration,
                    difference_duration: entry.difference_duration,
                    rating_duration: entry.rating_duration,
                    tolerance_duration: entry.tolerance_duration,
                    days_duration: entry.days_duration,
                    log_type_icon: entry.log_type_icon,
                    log_type_colour: entry.log_type_colour
                });
            });
        });
    
        return output;
    }
    
    // Usage
    // const aggregatedData = aggregateLogs(filteredData);
    const aggregatedData = aggregateLogs(result);
    // console.log(aggregatedData);




// This function then Formats correctly for Synfustion Series Model Graphing
// Chat GTP is a master in converting my ideas into code.... well done...!

// simple output.
          //   function transformToModel(data: Array<{
          //     name: string,
          //     log_type_name: string,
          //     count: number,
          // }>): Object[] {
          //     // First, group data by name
          //     const groupedData: Record<string, { name: string, counts: number[] }> = {};
          
          //     data.forEach(item => {
          //         if (!groupedData[item.name]) {
          //             groupedData[item.name] = { name: item.name, counts: [] };
          //         }
          //         groupedData[item.name].counts.push(item.count);
          //     });
          
          //     // Now transform the grouped data into the final format
          //     return Object.values(groupedData).map(group => {
          //         // Dynamically generate the 'y' fields based on the counts array
          //         const yFields = group.counts.reduce((acc, count, index) => {
          //             acc[`y${index + 1}`] = count;  // Create keys like y1, y2, y3, etc.
          //             return acc;
          //         }, {} as Record<string, number>);
          
          //         return {
          //             group: { x: group.name },  // 'x' is the name
          //             ...yFields  // Spread the dynamically generated 'y' fields into the object
          //         };
          //     });
          // }
          
          // // Example usage with aggregated data
          // const modelData = transformToModel(aggregatedData);
          
          // // You can now use modelData as the new structure
          // // console.log(modelData);





          function transformToModel(data: Array<{
            name: string,
            log_type_name: string,
            count: number,
            unit_per_day?: number,
            log_type_id?: number,
            when_from?: string,
            when_to?: string,
            Duration?: number,
            benchmark_duration?: number,
            difference_duration?: number,
            rating_duration?: number,
            tolerance_duration?: number,
            days_duration?: number,
            log_type_icon?: string,
            log_type_colour?: string
        }>): Object[] {
            // Group data by name
            const groupedData: Record<string, Record<string, any>> = {};
            
            data.forEach(item => {
                if (!groupedData[item.name]) {
                    groupedData[item.name] = {};
                }
                groupedData[item.name][item.log_type_name] = item; // Store the entire item by log_type_name
            });
        
            // Collect all unique log_type_names
            const allLogTypes = Array.from(new Set(data.map(item => item.log_type_name)));
        
            // Now transform the grouped data into the final format
            return Object.entries(groupedData).map(([name, logTypes]) => {
                const result: Record<string, any> = { group: { x: name } };
        
                allLogTypes.forEach((logType, index) => {
                    // Set yN values and fill missing data with 0
                    result[`y${index + 1}`] = {
                        count: logTypes[logType]?.count || 0,  // Use count or 0 if missing
                        log_type_name: logTypes[logType]?.log_type_name || logType,  // Use log_type_name or fallback to the key
                        unit_per_day: logTypes[logType]?.unit_per_day || 0,
                        log_type_id: logTypes[logType]?.log_type_id || null,
                        when_from: logTypes[logType]?.when_from || null,
                        when_to: logTypes[logType]?.when_to || null,
                        Duration: logTypes[logType]?.Duration || 0,
                        benchmark_duration: logTypes[logType]?.benchmark_duration || 0,
                        difference_duration: logTypes[logType]?.difference_duration || 0,
                        rating_duration: logTypes[logType]?.rating_duration || 0,
                        tolerance_duration: logTypes[logType]?.tolerance_duration || 0,
                        days_duration: logTypes[logType]?.days_duration || 0,
                        log_type_icon: logTypes[logType]?.log_type_icon || null,
                        log_type_colour: logTypes[logType]?.log_type_colour || null,
                    };
                });
        
                return result;
            });
        }
        
        // Example usage with aggregated data
        const modelData = transformToModel(aggregatedData);






// // auto empty records for non existant log types
//         function transformToModel(data: Array<{
//           name: string,
//           log_type_name: string,
//           count: number,
//           unit_per_day?: number,
//           log_type_id?: number,
//           when_from?: string,
//           when_to?: string,
//           Duration?: number,
//           benchmark_duration?: number,
//           difference_duration?: number,
//           rating_duration?: number,
//           tolerance_duration?: number,
//           days_duration?: number,
//           log_type_icon?: string,
//           log_type_colour?: string
//       }>): Object[] {
//           // Group data by name
//           const groupedData: Record<string, Record<string, any>> = {};
          
//           data.forEach(item => {
//               if (!groupedData[item.name]) {
//                   groupedData[item.name] = {};
//               }
//               groupedData[item.name][item.log_type_name] = item; // Store the entire item by log_type_name
//           });
      
//           // Collect all unique log_type_names
//           const allLogTypes = Array.from(new Set(data.map(item => item.log_type_name)));
      
//           // Now transform the grouped data into the final format
//           return Object.entries(groupedData).map(([name, logTypes]) => {
//               const result: Record<string, any> = { group: { x: name } };
      
//               allLogTypes.forEach((logType, index) => {
//                   // Create default values
//                   const defaultValues = {
//                       count: 0,
//                       log_type_name: logType, // Keep the log type name for reference
//                       unit_per_day: 0,
//                       log_type_id: null,
//                       when_from: null,
//                       when_to: null,
//                       Duration: 0,
//                       benchmark_duration: 0,
//                       difference_duration: 0,
//                       rating_duration: 0,
//                       tolerance_duration: 0,
//                       days_duration: 0,
//                       log_type_icon: null,
//                       log_type_colour: null,
//                   };
      
//                   // Use existing data or fall back to default values
//                   result[`y${index + 1}`] = {
//                       ...defaultValues,
//                       ...logTypes[logType]  // Merge with existing data, overriding defaults if they exist
//                   };
//               });
      
//               return result;
//           });
//       }
      
      // Example usage with aggregated data
// const modelData = transformToModel(aggregatedData);



        
        // You can now use modelData as the new structure
        console.log(modelData);













    this.ChartData_filtered_user_performance_FULL = modelData;




    }



// Staff Chart
// Transformation function with default color and icon
transformItemData2ToChartData(data: any): any[] {
  return data.flatMap(user => 
    user.user_logs_array.map(log => ({
      log_type_name: log.log_type_name,
      count: log.count,
      log_type_colour: log.log_type_colour || this.DEFAULT_COLOR, // Default color
      log_type_icon: log.log_type_icon || this.DEFAULT_ICON, // Default icon
      score_difference_duration: log.score_difference_duration, 
      user_icon: user.user_icon,
      benchmark_duration: log.benchmark_duration
    }))
  );
}

 // Custom tooltip content function
 public getTooltipContent(args: any): string {

  console.log("Tooltip data:", args.point);  // Log point data for debugging

  const icon = args.point.log_type_icon || this.DEFAULT_ICON;
  const xValue = args.point.x;
  const yValue = args.point.y;

  return `<div style="display:flex;align-items:center;">
              <i class="fa ${icon}"></i> 
              ${xValue}: ${yValue} 
          </div>`;
}



public tooltipRender(args: any): void {
  // Access log_type_icon and other properties safely
  const icon = args.point?.log_type_icon || this.DEFAULT_ICON;
  const xValue = args.point?.x;
  const yValue = args.point?.y;

  // Set custom HTML for tooltip
  // args.tooltip.header = '';
  args.tooltip.template = `<div style="display:flex;align-items:center;">
                              <i class="${icon}" style="margin-right:5px;"></i> 
                              ${xValue}: ${yValue}
                          </div>`;
}




calculateAnnotations(): void {
  if (!this.chartData2 || this.chartData2.length === 0) return;

  const sortedData = [...this.chartData2].sort((a, b) => b.score_difference_duration - a.score_difference_duration);

  // Identify top and bottom values
  this.highScoreAnnotation = [sortedData[0]];
  this.lowScoreAnnotations = sortedData.slice(-3);

  console.log("High Score Annotation:", this.highScoreAnnotation);
  console.log("Low Score Annotations:", this.lowScoreAnnotations);
}



}
